/**
 * filter generates an object whose values are the result of filtering a base object's key-value pairs with an
 * equivalence method, or shorthand string value.
 *
 * @param objectToTest the object to filter keys out of
 * @param predicate Must either be a function that returns a boolean value, or a string for shorthand truthy checking
 */
export const filter = <T extends Record<string, unknown>>(
  objectToTest: T = {} as T,
  predicate: ((value: T[keyof T], key?: keyof T, object?: T) => boolean) | string = () => true
): Partial<T> =>
  Object.fromEntries(
    Object.entries(objectToTest).filter(([key, nestedObjectValue]) =>
      typeof predicate === "string"
        ? !!(nestedObjectValue as Record<string, unknown>)[predicate]
        : predicate(nestedObjectValue as T[keyof T], key, objectToTest)
    )
  ) as Partial<T>;
